import { GYM, TCP, SNJ, PJP } from './brands.constants';
import { CATALOG_ID_CONFIG } from './brandSpecific.server.constants';

const SHOW_SMS_NOTIFICATION = {
  [TCP]: {
    USA: true,
    Canada: true,
  },
  [GYM]: {
    USA: true,
    Canada: false,
  },
  [SNJ]: {
    // BRAND-SPECIFIC-TODO
    USA: true,
    Canada: true,
  },
  [PJP]: {
    // PJP-ToDo
    USA: true,
    Canada: false,
  },
};

const SHOW_SMS_SIGN_UP = {
  [TCP]: {
    USA: true,
    Canada: true,
  },
  [GYM]: {
    USA: true,
    Canada: false,
  },
  [SNJ]: {
    // BRAND-SPECIFIC-TODO
    USA: true,
    Canada: true,
  },
  [PJP]: {
    // PJP-ToDo
    USA: true,
    Canada: false,
  },
};

export { CATALOG_ID_CONFIG, SHOW_SMS_NOTIFICATION, SHOW_SMS_SIGN_UP };
